import { render, staticRenderFns } from "./TableText.vue?vue&type=template&id=54fbe972&lang=html&"
import script from "./TableText.vue?vue&type=script&lang=js&"
export * from "./TableText.vue?vue&type=script&lang=js&"
import style0 from "./TableText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports